import React from "react";
import "./styles.css";

const iconsMap = {
    up: (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="11" viewBox="0 0 17 11" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.68169 2.08603L16.6877 0.0546875L14.9439 7.13774L12.7685 5.04937L9.25947 8.70462C9.14034 8.82871 8.97576 8.89886 8.80375 8.89886C8.63173 8.89886 8.46715 8.82871 8.34803 8.70462L5.77146 6.0207L1.98198 9.96807C1.74036 10.2198 1.34045 10.2279 1.08877 9.9863C0.837081 9.74468 0.82892 9.34478 1.07054 9.09309L5.31574 4.67101C5.43487 4.54692 5.59944 4.47677 5.77146 4.47677C5.94348 4.47677 6.10805 4.54692 6.22718 4.67101L8.80375 7.35493L11.8571 4.17439L9.68169 2.08603Z"
                fill="black"
            />
        </svg>
    ),
    down: (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6817 13.914L17.6877 15.9453L15.9439 8.86234L13.7685 10.9506L10.2595 7.29542C10.1403 7.17134 9.97576 7.1011 9.80375 7.1011C9.63173 7.1011 9.46715 7.17134 9.34803 7.29542L6.77146 9.97931L2.98198 6.03187C2.74036 5.7802 2.34045 5.77206 2.08877 6.01374C1.83708 6.25542 1.82892 6.65532 2.07054 6.90699L6.31574 11.329C6.43487 11.4531 6.59944 11.5232 6.77146 11.5232C6.94348 11.5232 7.10805 11.4531 7.22718 11.329L9.80375 8.64512L12.8571 11.8256L10.6817 13.914Z"
                fill="red"
            />
        </svg>
    ),
    warning: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M3.54846 6.45463C5.15758 3.60734 5.96213 2.18369 7.06619 1.81722C7.67352 1.61561 8.32779 1.61561 8.93512 1.81722C10.0392 2.18369 10.8437 3.60734 12.4529 6.45463C14.062 9.3019 14.8665 10.7256 14.6252 11.8856C14.4924 12.5238 14.1653 13.1026 13.6907 13.5392C12.828 14.3327 11.2189 14.3327 8.00065 14.3327C4.78242 14.3327 3.1733 14.3327 2.31063 13.5392C1.83604 13.1026 1.50891 12.5238 1.37613 11.8856C1.13478 10.7256 1.93934 9.3019 3.54846 6.45463Z"
                stroke="#FF7900"
                strokeWidth="1.15254"
            />
            <path
                d="M8.16081 11.3333V8.66667C8.16081 8.3524 8.16081 8.19527 8.06314 8.0976C7.96554 8 7.80841 8 7.49414 8"
                stroke="#FF7900"
                strokeWidth="1.15254"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.99414 6H8.00089" stroke="#FF7900" strokeWidth="1.15254" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    ),
};

const DashboardCardsPanel = ({financialSummary, isLoading = false}) => {
    const {
        income = {},
        outcome = {},
        profit = {},
        products_low_stock = 0,
    } = financialSummary || {};

    const formatCurrency = (value) => {
        if (value === undefined || value === null) return "$0";
        return value.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
        });
    };

    const formatVariation = (variation) => {
        const abs = Math.abs(variation);
        return `${variation >= 0 ? "+" : "-"}${abs}% respecto al mes anterior`;
    };

    const getIcon = (current, variation) => {
        if (current < 0) return "down";
        if (variation < 0) return "down";
        return "up";
    };

    const dashboardCards = [
        {
            title: "Ingresos",
            value: formatCurrency(income.current),
            icon: getIcon(income.current, income?.variation_percent),
            label: formatVariation(income?.variation_percent),
            bg: "purple",
        },
        {
            title: "Egresos",
            value: formatCurrency(outcome.current),
            icon: getIcon(outcome.current, outcome?.variation_percent),
            label: formatVariation(outcome?.variation_percent),
            bg: "blue",
        },
        {
            title: "Utilidad",
            value: formatCurrency(profit.current),
            icon: getIcon(profit.current, profit?.variation_percent),
            label: formatVariation(profit?.variation_percent),
            bg: "purple",
        },
        {
            title: "Alerta de inventario bajo",
            value: `${products_low_stock} productos`,
            icon: "warning",
            bg: "blue",
            showLabel: false,
        },
    ];

    return (
        <div
            className="accounting-dashboard-cards-container d-flex flex-row flex-wrap justify-content-between justify-content-xxl-center gap-xxl-5">
            {isLoading
                ?
                [...Array(4)].map((_, i) => (
                    <div
                        key={i}
                        className="accounting-dashboard-card skeleton p-4 pb-2 pt-5 gap-3 d-flex flex-column justify-content-end bg-loading"
                    >
                        <div className="accounting-dashboard-card-value skeleton w-100"/>
                        <div className="accounting-dashboard-card-value skeleton w-75"/>
                        <div className="accounting-dashboard-card-value skeleton w-25"/>
                    </div>
                ))
                : dashboardCards.map(({title, value, icon, label, bg = "blue", showLabel = true}, index) => {
                    const layoutClasses = showLabel ? "justify-content-end" : "justify-content-start";
                    const containerClasses = `accounting-dashboard-card p-4 pb-2 pt-5 gap-3 d-flex flex-column ${layoutClasses} bg-${bg}`;

                    return (
                        <div key={index} className={containerClasses}>
                            <div className="accounting-dashboard-card-title">{title}</div>
                            <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className="accounting-dashboard-card-value">{value}</div>
                                <div className="accounting-dashboard-card-icon">{iconsMap[icon]}</div>
                            </div>
                            {showLabel && <div className="accounting-dashboard-card-label">{label}</div>}
                        </div>
                    );
                })}
        </div>
    );
};

export default DashboardCardsPanel;
